import { Box, styled } from '@mui/material';
import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import MyCalendar from '../container/Calendar/Calendar';
// Detail status chip design preview (/dev/status-chips).
import StatusChipPreview from '../container/DevPreview/StatusChipPreview';
import Customers from '../container/Customers/Customers';
import NewCustomers from '../container/Customers/NewCustomers/NewCustomers';
import Profile from '../container/Customers/Profile/Profile';
import Dashboard from '../container/Dashboard/Dashboard';
import Estimates from '../container/Estimates/Estimates';
import Invoice from '../container/Invoice/Invoice';
import Shop from '../container/Shop/Shop';
import InviteCustomer from '../container/Sidebar/InviteCustomer';
import Notifications from '../container/Sidebar/Notifications';
import CommonSidebar from '../container/Sidebar/Sidebar';

import { clearAllPaths } from '../components/history';
import Appointments from '../container/Appointment/Appointment';
import AppointmentRequests from '../container/Appointment/AppointmentRequest';
import NewAppointmentV4 from '../container/Appointment/NewAppointment/NewAppointmentV4';
import PastAppointmentView from '../container/Appointment/PastAppointmentView/PastAppointmentView';
import Approvals from '../container/approval/Approval';
import CurrentApproval from '../container/approval/CurrentApproval/CurrentApproval';
import NewApprovals from '../container/approval/NewApprovals/NewApprovals';
import CalendarSetting from '../container/Calendar/CalendarSetting';
import ContactSupport from '../container/ContactSupport/ContactSupport';
import MergeCustomers from '../container/Customers/Merge';
import NewImportedCustomers from '../container/Customers/NewImportedCustomers/NewImportedCustomers';
import NewMergeCustomers from '../container/Customers/NewMerge';
import EstimateDetail from '../container/Estimates/EstimateDetail';
import EstimatesRequest from '../container/Estimates/EstimatesRequest/EstimatesRequest';
import EstimateEdit from '../container/Estimates/EstimateEdit';
import Inventory from '../container/Inventory/Inventory';
import InvoiceDetail from '../container/Invoice/InvoiceDetail';
import InvoiceEdit from '../container/Invoice/InvoiceEdit';
import RecordPaymentList from '../container/Invoice/RecordPayment/RecordPaymentList';
import CustomerChat from '../container/Messenger/CustomerChat';
import Messenger from '../container/Messenger/Messenger';
import NotFound from '../container/NotFound/NotFound';
import QuickReviewRequest from '../container/QuickReviewRequest';
import Requests from '../container/Requests/Requests';
import SubscriptionTiers from '../container/Shop/Billing/SubscriptionTiers';
import SiteMaintennance from '../container/SiteMaintenance/SiteMaintennance';
import NewSupplier from '../container/Suppliers/NewSupplier';
import SupplierNewInvoice from '../container/Suppliers/SupplierInvoice/NewSupplierInvoice';
import SupplierDraft from '../container/Suppliers/SupplierInvoice/SupplierDraft/SupplierDraft';
import SupplierInvoices from '../container/Suppliers/SupplierInvoice/SupplierInvoices';
import SupplierSent from '../container/Suppliers/SupplierInvoice/SupplierSent/SupplierSent';
import SupplierProfile from '../container/Suppliers/SupplierProfile/SupplierProfile';
import Suppliers from '../container/Suppliers/Suppliers';
import WorkOrderAuthorization from '../container/WorkOrderAuthorization/WorkOrderAuthorization';
import WorkOrders from '../container/WorkOrders/WorkOrders';
import WorkOrderDetail from '../container/WorkOrders/WorkOrderDetail';
import WorkOrderEdit from '../container/WorkOrders/WorkOrderEdit';
import { getItem } from '../utility/localStorage';

// TanStack Query Examples
const EmptyPage = () => {
    return <div></div>;
};
const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
}));
const PrivateRoutes = () => {
    const isCollapse = getItem('isCollapse');
    const [open, setOpen] = React.useState(isCollapse);
    const location = useLocation();

    const authData = JSON.parse(localStorage.getItem('apex-saas_details'));

    //Clear Search value from Customer list
    // useEffect(() => {
    //   if (location.pathname.split("/").includes("customers")) {
    //     if (location.pathname.split("/").includes("merge")) {
    //       localStorage.removeItem("searchValue");
    //     }
    //   } else {
    //     localStorage.removeItem("searchValue");
    //   }
    // }, [location]);
    useEffect(() => {
        if (window.innerWidth < 900) {
            setOpen(false);
        }
        const handleResize = () => {
            if (window.innerWidth < 900) {
                setOpen(false);
            }
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    useEffect(() => {
        if (!location.pathname.split('/').includes('new-appointment')) {
            clearAllPaths();
        }
    }, [location]);
    return (
        <>
            <Box sx={{ display: 'flex' }} className="mainBox_container">
                <CommonSidebar open={open} setOpen={setOpen} />
                <Box
                    component="main"
                    sx={{
                        width: open ? 'calc(100% - 288px)' : 'calc(100% - 65px)',
                    }}
                >
                    <DrawerHeader />
                    <Routes>
                        <Route exact path={'/'} element={authData?.allowedPlatforms.find((d) => d == 'web') ? <Dashboard /> : <EmptyPage />} />

                        {/* <Route exact path={"/dragNdrop"} element={<DragNDrop />} /> */}
                        {authData?.subscriptionStatus && authData?.subscriptionStatus == 'active' && (
                            <>
                                <Route exact path={'/account-settings/:name'} element={<Shop />} />
                                <Route exact path={'/account-settings/billing-plans'} element={<SubscriptionTiers />} />

                                <Route exact path={'/notifications'} element={<Notifications />} />
                                <Route exact path={'/referrals'} element={<InviteCustomer />} />
                                <Route exact path="contact-support" element={<ContactSupport />} />
                            </>
                        )}
                        {authData?.allowedPlatforms && authData?.allowedPlatforms.find((d) => d == 'web') && (
                            <>
                                <Route exact path={'/dashboard'} element={<Dashboard />} />

                                <Route exact path={'/customers'} element={<Customers />} />
                                <Route exact path={'/customers/new-customer'} element={<NewCustomers />} />
                                <Route exact path={'/customers/:id/:type?'} element={<Profile />} />
                                <Route exact path={'/customers/merge'} element={<MergeCustomers />} />
                                <Route exact path={'/customers/merge/new/'} element={<NewMergeCustomers />} />

                                {/* Invoice Listing Routes  */}
                                <Route exact path={'/invoice/all'} element={<Invoice />} />
                                <Route exact path={'/invoice/finalized'} element={<Invoice />} />
                                <Route exact path={'/invoice/sents'} element={<Invoice />} />
                                <Route exact path={'/invoice/drafts'} element={<Invoice />} />
                                <Route exact path={'/invoice/record-payment'} element={<RecordPaymentList />} />

                                {/* Invoice Detail Routes  */}
                                <Route exact path={'/invoice/draft/:id'} element={<InvoiceDetail />} />
                                <Route exact path={'/invoice/sent/:id'} element={<InvoiceDetail />} />
                                <Route exact path={'/invoice/finalized/:id'} element={<InvoiceDetail />} />

                                {/* finalize invoice */}
                                <Route exact path={'/invoice/edit/:id'} element={<InvoiceEdit />} />
                                <Route exact path={'/invoice/new'} element={<InvoiceEdit />} />
                                <Route exact path={'/invoice/new-invoice-from-estimate'} element={<InvoiceEdit />} />
                                <Route exact path={'/invoice/new-invoice-from-work-order'} element={<InvoiceEdit />} />
                                <Route exact path={'/invoice/edit-invoice-from-estimate/:id'} element={<InvoiceEdit />} />
                                <Route exact path={'/invoice/edit-invoice-from-work-order/:id'} element={<InvoiceEdit />} />
                                <Route exact path={'/invoice/new/:appointmentId'} element={<InvoiceEdit />} />
                                <Route exact path={'/invoice/new/:customerId/:type?'} element={<InvoiceEdit />} />

                                <Route exact path={'/estimates/requests'} element={<Estimates />} />
                                <Route exact path={'/estimates/all'} element={<Estimates />} />
                                <Route exact path={'/estimates/work-orders'} element={<Estimates />} />
                                <Route exact path={'/estimates/invoiced'} element={<Estimates />} />
                                <Route exact path={'/estimates/drafts'} element={<Estimates />} />
                                <Route exact path={'/estimates/draft/:id'} element={<EstimateDetail />} />
                                <Route exact path={'/estimates/sent/:id'} element={<EstimateDetail />} />
                                <Route exact path={'/estimates/work-order/:id'} element={<EstimateDetail />} />
                                <Route exact path={'/estimates/invoiced/:id'} element={<EstimateDetail />} />

                                <Route exact path={'/estimates/finalized'} element={<Estimates />} />
                                <Route exact path={'/estimates/finalized/:id'} element={<EstimateDetail />} />

                                {/* <Route exact path={"/estimates/request/:id"} element={<EstimatesRequest />} /> */}
                                <Route exact path={'/estimates/decline/:id'} element={<EstimatesRequest />} />
                                <Route exact path={'/estimates/accept/:id'} element={<EstimatesRequest />} />
                                <Route exact path={'/estimates/sents'} element={<Estimates />} />
                                {/* <Route exact path={'/estimates/sent'} element={<EstimatesSend />} /> */}
                                <Route exact path={'/estimates/edit/:id'} element={<EstimateEdit />} />
                                <Route exact path={'/estimates/estimate-request-edit/:estimateRequestId'} element={<EstimateEdit />} />
                                <Route exact path={'/estimates/new'} element={<EstimateEdit />} />
                                <Route exact path={'/estimates/new/:customerId/:type?'} element={<EstimateEdit />} />

                                {/* Work Orders — see docs/work-orders/WORK_ORDERS_SPEC.md */}
                                <Route exact path={'/work-orders/all'} element={<WorkOrders />} />
                                <Route exact path={'/work-orders/open'} element={<WorkOrders />} />
                                <Route exact path={'/work-orders/authorized'} element={<WorkOrders />} />
                                <Route exact path={'/work-orders/reapproval'} element={<WorkOrders />} />
                                <Route exact path={'/work-orders/invoiced'} element={<WorkOrders />} />
                                <Route exact path={'/work-orders/drafts'} element={<WorkOrders />} />
                                <Route exact path={'/work-orders/cancelled'} element={<WorkOrders />} />

                                <Route exact path={'/work-orders/draft/:id'} element={<WorkOrderDetail />} />
                                <Route exact path={'/work-orders/open/:id'} element={<WorkOrderDetail />} />
                                <Route exact path={'/work-orders/authorized/:id'} element={<WorkOrderDetail />} />
                                <Route exact path={'/work-orders/reapproval/:id'} element={<WorkOrderDetail />} />
                                <Route exact path={'/work-orders/invoiced/:id'} element={<WorkOrderDetail />} />
                                <Route exact path={'/work-orders/cancelled/:id'} element={<WorkOrderDetail />} />

                                {/* Detail status chip design preview — see src/common/DetailStatusChip.jsx */}
                                <Route exact path={'/dev/status-chips'} element={<StatusChipPreview />} />
                                <Route exact path={'/work-orders/new'} element={<WorkOrderEdit />} />
                                <Route exact path={'/work-orders/edit/:id'} element={<WorkOrderEdit />} />
                                <Route exact path={'/work-orders/new/:appointmentId'} element={<WorkOrderEdit />} />
                                <Route exact path={'/work-orders/new-from-estimate'} element={<WorkOrderEdit />} />
                                <Route exact path={'/work-orders/edit-from-estimate/:id'} element={<WorkOrderEdit />} />

                                <Route exact path={'/approvals/waiting'} element={<Approvals />} />
                                <Route exact path={'/approvals/responded'} element={<Approvals />} />
                                <Route exact path={'/approvals/deferred'} element={<Approvals />} />
                                <Route exact path={'/appointment/newApproval/:id'} element={<NewApprovals />} />
                                <Route exact path={'/appointment/workOrderAuthorization/:id'} element={<WorkOrderAuthorization openSidebar={open} />} />
                                <Route exact path={'/workOrderAuthorization/:id'} element={<WorkOrderAuthorization openSidebar={open} />} />
                                <Route exact path={'/approval/:id'} element={<CurrentApproval />} />

                                <Route exact path={'/calendar/:calendarView?'} element={<MyCalendar />} />

                                {/* <Route exact path={"/appointments"} element={<Appointments />} /> */}
                                <Route exact path={'/appointment/today'} element={<Appointments />} />
                                <Route exact path={'/appointment/upcoming-appointments'} element={<Appointments />} />
                                <Route exactApprovals path={'/appointment/past-appointments'} element={<Appointments />} />
                                <Route exact path={'/appointment/past-appointment/:id'} element={<PastAppointmentView />} />

                                <Route exact path={'/appointment/new-appointment'} element={<NewAppointmentV4 />} />
                                {/* <Route exact path={'/appointment/new-appointment-v4'} element={<NewAppointmentV4 />} /> */}
                                <Route exact path={'/appointment/new-appointment/:id/:type?'} element={<NewAppointmentV4 />} />

                                <Route exactApprovals path={'/requests/outstanding'} element={<AppointmentRequests />} />
                                <Route exactApprovals path={'/requests/accepted'} element={<AppointmentRequests />} />
                                <Route exactApprovals path={'/requests/declined'} element={<AppointmentRequests />} />
                                <Route exactApprovals path={'/requests/proposed'} element={<AppointmentRequests />} />
                                <Route exactApprovals path={'/requests/expired'} element={<AppointmentRequests />} />

                                <Route exact path="/request/appointments" element={<Requests />} />
                                <Route exact path="/request/estimates" element={<Requests />} />
                                <Route exact path="/calendar/settings" element={<CalendarSetting />} />
                                <Route exact path="/messenger/:id?" element={<Messenger />} />
                                <Route exact path="/customerChat/:id" element={<CustomerChat />} />

                                <Route exact path="/customers/imported-customer/:id" element={<NewImportedCustomers />} />

                                <Route exact path={'/suppliers'} element={<Suppliers />} />
                                <Route exact path={'/suppliers/new'} element={<NewSupplier />} />
                                <Route exact path={'/suppliers/:id'} element={<SupplierProfile />} />

                                <Route exact path={'/suppliers-invoice/:id'} element={<SupplierNewInvoice />} />
                                <Route exact path={'/suppliers/suppliers-invoice/:supplierId'} element={<SupplierNewInvoice />} />
                                <Route exact path={'/suppliers-invoice/all'} element={<SupplierInvoices />} />

                                <Route exact path={'/suppliers-invoice/open'} element={<SupplierInvoices />} />
                                <Route exact path={'/suppliers-invoice/open/:id'} element={<SupplierSent />} />

                                <Route exact path={'/suppliers-invoice/paid'} element={<SupplierInvoices />} />
                                <Route exact path={'/suppliers-invoice/paid/:id'} element={<SupplierSent />} />

                                <Route exact path={'/suppliers-invoice/partial'} element={<SupplierInvoices />} />
                                <Route exact path={'/suppliers-invoice/partial/:id'} element={<SupplierSent />} />

                                <Route exact path={'/suppliers-invoice/draft'} element={<SupplierInvoices />} />
                                <Route exact path={'/suppliers-invoice/draft/:id'} element={<SupplierDraft />} />
                                <Route exact path={'/suppliers-invoice/new'} element={<SupplierNewInvoice />} />
                                <Route exact path={'/suppliers-invoice/draft/:id'} element={<SupplierNewInvoice />} />
                                <Route exact path="/inventory/all" element={<Inventory />} />
                                <Route exact path="/inventory/parts" element={<Inventory />} />
                                <Route exact path="/inventory/tires" element={<Inventory />} />
                                <Route exact path="/site-maintenance" element={<SiteMaintennance />} />

                                <Route exact path="/reviews" element={<QuickReviewRequest />} />
                            </>
                        )}

                        <Route exact path={'/*'} element={<NotFound />} />
                    </Routes>
                </Box>
            </Box>
        </>
    );
};

export default PrivateRoutes;
